import { Alert, Button, Stack } from '@mui/material';
import React, { MutableRefObject } from 'react';
import styles from './PrintButton.module.css';
import { printHtml } from './PrintContainer';

interface PrintButtonProps {
  printContents: MutableRefObject<HTMLDivElement>;
}

export const PrintButton: React.FC<PrintButtonProps> = ({ printContents }) => {
  const [error, setError] = React.useState<string>();

  const onClick = () => {
    const result = printHtml(printContents.current.innerHTML);
    if (!result) {
      setError('Printing has not been enabled. Add a PrintContainer.');
    }
  };

  return (
    <Stack sx={{ mt: 2 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <div className={styles.printButtonWrapper}>
        <div></div>
        <Button variant="contained" onClick={onClick}>
          Skriv ut
        </Button>
      </div>
    </Stack>
  );
};

